import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/facilities/$facilityKey/rooms/registration")({
  beforeLoad({ params, search }) {
    // 過去に使用されていたルートを最新のルートにリダイレクトする。
    throw redirect({ params, search, to: "/facilities/$facilityKey/beds/registration" });
  },
});
